import type { SismaDTO } from '../../dto/plc/sisma-dto'
import type { Earthquake } from '../../types/plc/earthquake'

const mapToEarthquake = (dto: SismaDTO): Earthquake => {
    return {
        id: dto.id,
        value: dto.campo ?? null,
        secondValue: dto.campo2 ?? null,
        alarmId: dto.idAllarmi,
        alarmName: dto.nomeAllarmi ?? null,
        nota: dto.nota
        
    }
}

const mapToSismaDTO = (earthquake: Earthquake): SismaDTO => {
    return {
        id: earthquake.id,
        campo: earthquake.value ?? null,
        campo2: earthquake.secondValue ?? null,
        idAllarmi: earthquake.alarmId,
        nomeAllarmi: earthquake.alarmName,
        nota: earthquake.nota
    }
}

export { mapToEarthquake, mapToSismaDTO }
